import '../sass/project.scss';

import Alpine from 'alpinejs';
import 'htmx.org';
import 'leaflet/dist/leaflet.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

window.Alpine = Alpine;

window.__ = window.gettext || ((text) => text);

document.addEventListener('htmx:configRequest', (event) => {
  const csrfMeta = document.querySelector('meta[name="csrf-token"]');
  if (csrfMeta && !event.detail.headers['X-CSRFToken']) {
    event.detail.headers['X-CSRFToken'] = csrfMeta.content;
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (
    document.querySelector('[data-leaflet]') ||
    document.getElementById('infra-map')
  ) {
    import(/* webpackChunkName: "maps" */ './maps').then((m) => {
      m.initLeafletMaps();
      m.initInfraMap();
    });
  }
  if (document.querySelector('canvas[data-chart]')) {
    import(/* webpackChunkName: "charts" */ './charts').then((m) =>
      m.initCharts(),
    );
  }
});
